import {PrintData} from "./print-data";
import {urlToBase64} from "./url-to-base64";

/**
 * (PDF) 출고보류라벨 출력데이터
 */
export default new PrintData({
    id: '',
    desc: 'PDF방식 출고보류라벨 출력',

    makeQzDataPromise: (house_id) => {
        let url = `/houses/${house_id}/shipout-hold-label?__accept=pdf&outline=no`;

        return urlToBase64(url)
            .then((base64) => {
                return new Promise((resolve, reject) => {
                    let data = [{
                        type: 'pixel',
                        format: 'pdf',
                        flavor: 'base64',
                        data: base64,
                        options: { ignoreTransparency: true }
                    }];
                    resolve(data);

                    console.log('pdf 출고보류라벨 데이터 생성완료!');

                });
            });


    },
})